import { Button } from 'primereact/button';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { AGENTROLE, COACHING, MYMETRICS, SUPERVISORROLE } from '../../constants';
import { selectCurrentRole } from '../../pages/login/authSlice';
import { CoachingTabs } from '../../utils/typeConstants';
import './quickLinks.css';

const QuickLinks = () => {
    const role = useSelector(selectCurrentRole);
    const navigate = useNavigate();

    const links = [
        {
            label: 'To Do',
            color: 'green',
            url: COACHING + '/' + CoachingTabs.MyTODos + '/' + 1,
            icon: 'pi pi-external-link',
        },
        {
            label: 'Discussions',
            color: 'blue',
            url: COACHING + '/' + CoachingTabs.Conversation + '/' + 1,
            icon: 'pi pi-external-link',
        },
    ];

    if (role === SUPERVISORROLE || role === AGENTROLE) {
        links.unshift({ label: 'My Metrics', color: 'teal', url: MYMETRICS, icon: 'pi pi-external-link' });
    }

    const handleCardClick = (e: any, link: any) => {
        navigate(link.url, { replace: true });
    };
    return (
        <div className="p-4">
            <h3 className="text-gray-800 text-lg mb-3">Quick Links</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 links">
                {links.map((link) => (
                    <Button
                        key={link.label}
                        label={link.label}
                        icon={link.icon}
                        iconPos="left"
                        className="p-button-outlined p-button-rounded"
                        onClick={(e) => handleCardClick(e, link)}
                        style={{ backgroundColor: 'white', color: link.color }}
                    />
                ))}
            </div>
        </div>
    );
};

export default QuickLinks;
